module.exports = __webpack_public_path__ + "static/media/PHEV.f5d5a171.svg";